const GrothBack = [
    {id: "0", value: "成長"},    
    {id: "1", value: "衰退"},   
  ];  
  
  export default GrothBack